<template>
  <div class="bg-light min100vh">
    <div class="container maxW600 py-5">
      <div class="row justify-content-md-center">
        <div class="col text-center">
          <slot name="title" />
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div :class="['col maxW500 bg-white rounded py-5']">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'solo-card',
};
</script>

<style scoped>
.maxW600 {
  max-width: 600px;
}
.min100vh {
  min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/components/SoloCard.vue